import { render, staticRenderFns } from "./resumeAssign.vue?vue&type=template&id=74d5b6a3"
import script from "./resumeAssign.vue?vue&type=script&lang=js"
export * from "./resumeAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports